export const buildYourDreamBagButtons = {
  primary: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '370px',
    height: '40px',
    maxWidth: ['90dvw', '95%'],
    p: '8px',
    borderRadius: '40px',
    border: 'none',
    background: '#f37021',
    color: 'white',
    fontFamily: 'din-medium-cn',
    fontSize: '18px',
    fontStyle: 'italic',
    fontWeight: 600,
    lineHeight: '24px',
    letterSpacing: 1.2,
    cursor: 'pointer',
    textTransform: 'none',
    transition: 'background 0.3s ease-in-out',

    '&:hover': {
      borderRadius: '40px',
      color: '#f37021',
      background: 'white',
    },

    '&:active, &:focus': {
      border: '1.5px solid #f37021',
      color: '#f37021',
      background: 'white',
    },

    '&:disabled': {
      background: 'rgba(159, 174, 175, 0.40)',
      color: 'rgba(255,255,255,.26)',
      cursor: 'not-allowed',
    },
  },

  secondary: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '370px',
    maxWidth: ['90dvw', '95%'],
    height: '40px',
    p: '8px',
    borderRadius: '40px',
    background: 'rgba(0,0,0,0.8)',
    color: 'bydb-white',
    fontFamily: 'din-medium-cn',
    fontSize: '16px',
    fontStyle: 'italic',
    fontWeight: 600,
    lineHeight: '24px',
    letterSpacing: 1.2,
    cursor: 'pointer',
    textTransform: 'none',
    border: '1.5px solid white',
    transition: 'background 0.3s ease-in-out',

    '&:hover': {
      borderRadius: '40px',
      color: '#f37021',
    },

    '&:active, &:focus': {
      background: '#f37021',
      border: '1.5px solid white',
    },

    '&:disabled': {
      background: 'rgba(159, 174, 175, 0.40)',
      color: 'rgba(255,255,255,.26)',
      cursor: 'not-allowed',
    },
  },

  outline: {
    color: 'textLight',
    fontFamily: 'din-light-cn',
    fontSize: '16px',
    fontStyle: 'normal',
    lineHeight: '24px',
    borderRadius: '40px',
    border: '1px solid #FFF',
    background: 'transparent',
    padding: '8px 16px',
    userSelect: 'none',

    '&:hover': {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  },
  link: {
    color: '#f37021',
    fontFamily: 'bold',
    fontSize: '20px',
    fontStyle: 'italic',
    textDecorationLine: 'underline',
    textAlign: 'center',
    width: '100%',
    cursor: 'pointer',
    background: 'transparent',
  },
}

export const greatestHitsButtons = {
  primary: {
    fontFamily: 'regular',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: 700,
    textTransform: 'uppercase',
    borderRadius: '40px',
    border: '1.5px solid #FFF',
    background:
      'linear-gradient(0deg, #000 0%, var(--theme-ui-colors-background) 100%)',
    padding: '8px',
    width: '100%',
  },
  homeButton: {
    color: 'white',
    width: ['90%', '400px'],
    minWidth: ['200px', '400px'],
    fontSize: ['18px', '24px'],
    fontFamily: 'bold',
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    mt: ['20px', '30px'],
    mb: ['30px', '20px'],
    background: 'primary',
    borderRadius: '30px',
  },
  submitContainer: {
    variant: 'text.mediumBold',
    display: 'flex',
    justifyContent: 'center',
    width: ['100%', '100%', '400px'],
    minWidth: ['200px', '200px', '400px'],
    borderRadius: '56.25px',

    '&:hover': {
      color: 'textLight',
      background: 'secondary',
    },

    button: {
      background: 'primary',
      lineHeight: '18px',
      mx: '0px',
      p: '12px 60px',
    },
  },
}

export const ultimateCoachingTripButtons = {
  submit: {
    width: '100%',
    background: 'textLight',
    borderRadius: '0',
    p: '16px 24px',
    variant: 'text.mediumBold',
    color: 'textDark',
  },
  small: {
    background: 'textLight',
    borderRadius: '0',
    variant: 'text.smallBold',
    fontSize: '11.813px',
    color: 'textDark',
    p: '9.45px 0',
  },
}

export const stwButtons = {
  primary: {
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    bottom: '30px',
    height: '46px',
    width: '391px !important',
    maxWidth: '90vw',
    fontFamily: 'din-bold',
    zIndex: 3,
    background: 'linear-gradient(0deg, #000000 20%, #757575)',
    border: 'solid 1.5px white !important',
    borderRadius: '77px !important',
    textTransform: 'uppercase',
    fontSize: '20px',
    transition: 'filter 0.2s ease-in-out',
    pb: '13px !important',

    '&:hover': {
      cursor: 'pointer',
      filter: 'brightness(1.2)',
    },
  },
}
